import { useAuth } from "@/context/AuthContext";
import { AlertTriangle, X } from "lucide-react";
import { useState } from "react";

/** Persistent banner shown site-wide when the caller is logged in with a demo account.
 *  Signals "you're inside a live-fidelity tour, some destructive actions are locked."
 *  Can be dismissed for the current session so screenshots stay clean during the demo.
 */
export default function DemoBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("klfn_demo_banner_dismissed") === "1");

  if (!user || !user.is_demo || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem("klfn_demo_banner_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="demo-banner"
      className="w-full border-b border-[#d4b876]/40 bg-[#d4b876]/8 backdrop-blur-sm relative z-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 py-2 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 min-w-0">
          <AlertTriangle size={13} style={{ color: "#d4b876" }} className="shrink-0" />
          <div className="font-mono text-[11px] text-white/85 min-w-0">
            <span className="label-mono mr-2" style={{ color: "#d4b876" }}>::: DEMO MODE</span>
            <span className="text-white/70">
              You're touring the portal as a demo Chief. Every module is fully usable —
              only destructive actions (delete, approve/reject applicants, terminate staff) are locked to protect real Nation data.
            </span>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="text-white/50 hover:text-white shrink-0"
          data-testid="dismiss-demo-banner"
          title="Dismiss for this session"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
